import { gql } from '@apollo/client'

/** Fetches the user's LLM credit balance — always use network-only to get fresh data. */
const UserBalance = gql`
    query UserBalance {
        user {
            id
            llmCreditBalance
        }
    }
`

export default UserBalance

